import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const Footer = () => (
  <footer data-testid="footer" className="border-t border-stone-200 bg-stone-50">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
      <div>
        <p data-testid="footer-brand" className="font-['Manrope'] font-bold text-lg tracking-tight text-stone-900">
          CafeTransport<span className="text-orange-600">.pro</span>
        </p>
        <p className="mt-2 text-sm text-stone-500">
          Corporate transportation solutions for modern businesses.
        </p>
      </div>
      <nav className="flex items-center gap-6 text-sm">
        <Dialog>
          <DialogTrigger asChild>
            <button
              data-testid="footer-privacy-link"
              className="text-stone-600 hover:text-stone-900 transition-colors duration-200"
            >
              Privacy Policy
            </button>
          </DialogTrigger>
          <DialogContent data-testid="privacy-dialog" className="max-w-lg">
            <DialogHeader>
              <DialogTitle className="font-['Manrope']">Privacy Policy</DialogTitle>
            </DialogHeader>
            <div className="text-sm text-stone-600 leading-relaxed space-y-4">
              <p>
                When you submit the assessment form, we collect the details you provide
                (company, contact and transportation requirements) solely to review your
                inquiry and respond to you.
              </p>
              <p>
                We do not sell, rent or share your information with third parties for
                marketing. Your submission is sent to our team by email and stored securely.
              </p>
              <p>
                To request correction or deletion of your data, contact us at{" "}
                <a href="mailto:info@cafetransport.pro" className="text-orange-600 hover:text-orange-700">
                  info@cafetransport.pro
                </a>
                .
              </p>
            </div>
          </DialogContent>
        </Dialog>
        <a
          href="mailto:info@cafetransport.pro"
          data-testid="footer-contact-link"
          className="text-stone-600 hover:text-stone-900 transition-colors duration-200"
        >
          Contact
        </a>
      </nav>
    </div>
    <div className="border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5">
        <p className="text-xs text-stone-400">&copy; {new Date().getFullYear()} CafeTransport.pro. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
